import styled from 'styled-components';
import {
  Collapse,
} from 'antd';
// import {
//   COLOR_CV_6,
// } from 'constants/colors';

export const StyledAntdCollapse = styled(Collapse)`
`;
